module.exports = __webpack_public_path__ + "assets/img/A4-1-child.a2effa4c.jpg";